import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { AnalyticsTemplate } from '~/analytics/domains/page/ui/AnalyticsTemplate';
import { AnalyticsView } from '~/analytics/views/analytics/AnalyticsView';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

export const AnalyticsUserRouter = (): React.ReactElement => {
  return (
    <AnalyticsTemplate>
      <Routes>
        {/*
          Serve the analytics dashboard at the index path. We intentionally do
          NOT use `/analytics` here: a static `/analytics/*` route already exists
          in the capital-provider tree (core/routes/analytics), and React Router
          matches that more-specific route before reaching this persona router.
        */}
        <Route
          path="/"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <AnalyticsView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnalyticsTemplate>
  );
};
